// import React, { useState, useEffect } from "react";
// import { Link, useLocation } from "react-router-dom";

// // Sample products data with working Unsplash image URLs
// const productsData = [
//   // ICT Hardware
//   {
//     id: 1,
//     name: "Desktop Computer",
//     description: "High-performance desktop for office and personal use.",
//     price: "$799",
//     img: "https://images.unsplash.com/photo-1581091215367-1f5f3e5d7e13?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60",
//     alt: "Desktop Computer",
//   },
//   {
//     id: 2,
//     name: "Laptop Computer",
//     description: "Portable laptop for work, gaming, and personal use.",
//     price: "$1,099",
//     img: "https://images.unsplash.com/photo-1517336714731-489689fd1ca8?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60",
//     alt: "Laptop Computer",
//   },
//   {
//     id: 3,
//     name: "Printer",
//     description: "All-in-one printer for home or office use.",
//     price: "$299",
//     img: "https://images.unsplash.com/photo-1581091215367-9b7e5d5b5f10?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60",
//     alt: "Printer",
//   },
//   {
//     id: 4,
//     name: "CCTV Camera",
//     description: "High-definition CCTV camera for security surveillance.",
//     price: "$149",
//     img: "https://images.unsplash.com/photo-1581092588427-4f7c7b0e2f13?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60",
//     alt: "CCTV Camera",
//   },
//   {
//     id: 5,
//     name: "UPS Backup System",
//     description: "Uninterruptible power supply to protect your devices.",
//     price: "$199",
//     img: "https://images.unsplash.com/photo-1581091870625-77c1b1f0e2d3?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60",
//     alt: "UPS Backup",
//   },
//   {
//     id: 6,
//     name: "Wireless Router",
//     description: "High-speed router for seamless internet connectivity.",
//     price: "$99",
//     img: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60",
//     alt: "Wireless Router",
//   },

//   // Stationery & Office
//   {
//     id: 7,
//     name: "A4 Paper Pack",
//     description: "High-quality A4 paper for printing and office use.",
//     price: "$15",
//     img: "https://images.unsplash.com/photo-1581091215365-d2a7d7f7c9d0?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60",
//     alt: "A4 Paper Pack",
//   },
//   {
//     id: 8,
//     name: "Ink Cartridges",
//     description: "Compatible ink cartridges for various printer models.",
//     price: "$25",
//     img: "https://images.unsplash.com/photo-1581091012183-7eae2b4e7d8f?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60",
//     alt: "Ink Cartridges",
//   },
//   {
//     id: 9,
//     name: "Office Chair",
//     description: "Ergonomic office chair for comfort and productivity.",
//     price: "$129",
//     img: "https://images.unsplash.com/photo-1581091215367-9b7e5d5b5f10?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60",
//     alt: "Office Chair",
//   },
//   {
//     id: 10,
//     name: "Office Desk",
//     description: "Spacious desk suitable for any workspace.",
//     price: "$199",
//     img: "https://images.unsplash.com/photo-1581091012184-65b3b6a2b8f1?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60",
//     alt: "Office Desk",
//   },

//   // Branding & Print Products
//   {
//     id: 11,
//     name: "Custom T-shirt",
//     description: "Personalized branded T-shirts for your business or event.",
//     price: "$19",
//     img: "https://images.unsplash.com/photo-1593032465179-5dc867e3de82?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60",
//     alt: "Custom T-shirt",
//   },
//   {
//     id: 12,
//     name: "Branded Mug",
//     description: "Custom printed mugs for promotional or corporate use.",
//     price: "$12",
//     img: "https://images.unsplash.com/photo-1581092588427-4f7c7b0e2f13?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60",
//     alt: "Branded Mug",
//   },
//   {
//     id: 13,
//     name: "Business Banner",
//     description: "High-quality printed banners for advertising and events.",
//     price: "$49",
//     img: "https://images.unsplash.com/photo-1581091215367-1f5f3e5d7e13?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60",
//     alt: "Business Banner",
//   },
//   {
//     id: 14,
//     name: "Flyers / Leaflets",
//     description: "Custom printed flyers for your business promotions.",
//     price: "$29",
//     img: "https://images.unsplash.com/photo-1581091215365-d2a7d7f7c9d0?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=60",
//     alt: "Flyers / Leaflets",
//   },
// ];
// function AllProducts() {
//   const [searchTerm, setSearchTerm] = useState("");
//   const { pathname } = useLocation();

//   // Scroll to top on route change
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [pathname]);

//   // Set document title
//   useEffect(() => {
//     document.title = "All Products - Tech Solutions"; // Set page title
//   }, []);

//   // Filter products based on search term
//   const filteredProducts = productsData.filter((product) =>
//     product.name.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   return (
//     <section
//       id="all-products"
//       className="py-12 px-4 bg-gray-50 bg-cover bg-center"
//       style={{
//         minHeight: "calc(100vh - 60px)",
//         backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80')`,
//       }}
//     >
//       <div className="text-center mb-8">
//         <h3 className="text-2xl md:text-3xl font-bold text-white mb-2">
//           All Products
//         </h3>
//         <p className="text-sm md:text-base text-gray-200">
//           Browse our full range of high-quality tech products.
//         </p>
//       </div>

//       {/* Search Bar */}
//       <div className="max-w-lg mx-auto mb-8">
//         <input
//           type="text"
//           placeholder="Search products..."
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//           className="w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
//         />
//       </div>

//       {/* Products Grid */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-4xl mx-auto">
//         {filteredProducts.length > 0 ? (
//           filteredProducts.map((product) => (
//             <div
//               key={product.id}
//               className="bg-white p-4 rounded-xl shadow-md border-t-2 border-blue-500 hover:shadow-lg transition duration-300 transform hover:-translate-y-1"
//             >
//               <div className="flex justify-center items-center h-24 w-24 mx-auto mb-3 bg-blue-100 rounded-md overflow-hidden">
//                 <img
//                   src={product.img}
//                   alt={product.alt}
//                   className="h-full w-full object-cover"
//                   loading="lazy"
//                 />
//               </div>
//               <h4 className="text-base md:text-lg font-semibold text-center mb-1">
//                 {product.name}
//               </h4>
//               <p className="text-xs md:text-sm text-gray-600 text-center">
//                 {product.description}
//               </p>
//               {/* <p className="text-lg font-bold text-blue-600 text-center mt-2">
//                 {product.price}
//               </p>
//               <button className="mt-3 w-full bg-blue-600 text-white py-1.5 rounded-lg hover:bg-blue-700 transition-colors text-sm">
//                 Add to Cart
//               </button> */}
//             </div>
//           ))
//         ) : (
//           <p className="text-gray-500 col-span-full text-center">
//             No products found for "{searchTerm}".
//           </p>
//         )}
//       </div>

//       {/* View All Products Button */}
//       {/* <div className="text-center mt-8">
//         <Link
//           to="/products"
//           className="px-4 py-2 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 transition text-sm md:text-base"
//         >
//           Back to Featured Products
//         </Link>
//       </div> */}
//     </section>
//   );
// }

// export default AllProducts;

// AllProducts.tsx
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  FaLaptop,
  FaNetworkWired,
  FaServer,
  FaPrint,
  FaClipboardList,
  FaSearch,
} from "react-icons/fa";

const kevmarkProducts = [
  // === ICT HARDWARE ===
  {
    id: 1,
    name: "HP ProDesk 400 G9",
    description: "Business-grade desktop with Intel i5, 8GB RAM, 256GB SSD.",
    price: "UGX 2,800,000",
    icon: <FaLaptop className="w-6 h-6 text-blue-600" />,
    img: "https://www.techly.com/media/catalog/product/2/0/20-56_2.jpg",
  },
  {
    id: 2,
    name: "Lenovo ThinkPad L14",
    description:
      '14" laptop, Ryzen 5, 16GB RAM, 512GB SSD – perfect for office.',
    price: "UGX 3,200,000",
    icon: <FaLaptop className="w-6 h-6 text-indigo-600" />,
    img: "https://images.unsplash.com/photo-1517336714731-489689fd1ca8?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 3,
    name: "Epson L3250 Printer",
    description: "Wi-Fi all-in-one ink tank printer – print, scan, copy.",
    price: "UGX 980,000",
    icon: <FaPrint className="w-6 h-6 text-red-600" />,
    img: "https://images.unsplash.com/photo-1581091215367-9b7e5d5b5f10?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 4,
    name: "Hikvision 4MP CCTV Kit",
    description: "4-channel DVR + 4 outdoor cameras, night vision, mobile app.",
    price: "UGX 1,650,000",
    icon: <FaServer className="w-6 h-6 text-teal-600" />,
    img: "https://images.unsplash.com/photo-1581092588427-4f7c7b0e2f13?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 5,
    name: "APC 650VA UPS",
    description: "Uninterruptible power supply – protects PCs & printers.",
    price: "UGX 420,000",
    icon: <FaServer className="w-6 h-6 text-gray-600" />,
    img: "https://images.unsplash.com/photo-1581091870625-77c1b1f0e2d3?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 6,
    name: "TP-Link Archer AX55",
    description: "Wi-Fi 6 router, dual-band, 3000 Mbps, 4 antennas.",
    price: "UGX 380,000",
    icon: <FaNetworkWired className="w-6 h-6 text-purple-600" />,
    img: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=800&q=80",
  },

  // === STATIONERY & OFFICE ===
  {
    id: 7,
    name: "Double A A4 Paper (500 sheets)",
    description: "Premium 80gsm paper for printing and copying.",
    price: "UGX 28,000",
    icon: <FaClipboardList className="w-6 h-6 text-orange-600" />,
    img: "https://m.media-amazon.com/images/I/81K5l37CaGL.jpg",
  },
  {
    id: 8,
    name: "HP 680 Ink Cartridge",
    description: "Black & tri-color combo pack – compatible with DeskJet.",
    price: "UGX 85,000",
    icon: <FaPrint className="w-6 h-6 text-red-600" />,
    img: "https://images.unsplash.com/photo-1581091012183-7eae2b4e7d8f?auto=format&fit=crop&w=800&q=80",
  },

  // === BRANDING & PRINTING ===
  {
    id: 9,
    name: "Custom Branded T-Shirt",
    description: "100% cotton, full-color DTG print, any design.",
    price: "UGX 45,000",
    icon: <FaPrint className="w-6 h-6 text-pink-600" />,
    img: "https://images.unsplash.com/photo-1593032465179-5dc867e3de82?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 10,
    name: "A3 Glossy Poster (100 pcs)",
    description: "Full-color, 200gsm, ideal for events & promotions.",
    price: "UGX 180,000",
    icon: <FaPrint className="w-6 h-6 text-red-600" />,
    img: "https://image.made-in-china.com/2f0j00odjthYMCySqO/3-2m-Advertisement-PVC-Banner-Large-Format-Printer.webp",
  },
  {
    id: 11,
    name: "Business Cards (500 pcs)",
    description: "350gsm matte, double-sided, premium finish.",
    price: "UGX 75,000",
    icon: <FaPrint className="w-6 h-6 text-purple-600" />,
    img: "https://media.licdn.com/dms/image/v2/D4E12AQE5h7fOUJoqnQ/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1690827620760?e=2147483647&t=-fQaTqvuEGfAllY3HAgLAEpPhjMWKH_zMLdps3IzZfM&v=beta",
  },
];

function AllProducts() {
  const [searchTerm, setSearchTerm] = useState("");
  const { pathname } = useLocation();

  // Scroll to top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // Set title
  useEffect(() => {
    document.title = "All Products - KevMark Investments";
  }, []);

  // Filter by name or description
  const filteredProducts = kevmarkProducts.filter(
    (p) =>
      p.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      p.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="relative min-h-screen">
      {/* === SMOOTH BACKGROUND === */}
      <div className="absolute inset-0 z-10">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-white to-purple-50" />
        <div className="absolute top-10 left-10 w-96 h-96 bg-blue-300 rounded-full filter blur-3xl opacity-20 animate-pulse" />
        <div className="absolute top-32 right-20 w-80 h-80 bg-purple-300 rounded-full filter blur-3xl opacity-15 animate-pulse delay-700" />
        <div className="absolute bottom-20 left-32 w-72 h-72 bg-teal-300 rounded-full filter blur-3xl opacity-10 animate-pulse delay-1000" />
        <div className="absolute bottom-10 right-40 w-64 h-64 bg-pink-300 rounded-full filter blur-3xl opacity-10 animate-pulse delay-300" />
        <div className="absolute top-0 left-0 right-0 h-32 bg-gradient-to-b from-white to-transparent" />
      </div>

      {/* === CONTENT === */}
      <div className="relative z-10 py-16 px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900">
            All Products
          </h1>
          <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto">
            From hardware to stationery and custom printing — everything your
            business needs.
          </p>
        </div>

        {/* Search Bar */}
        <div className="max-w-2xl mx-auto mb-12">
          <div className="relative">
            <FaSearch className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
            <input
              type="text"
              placeholder="Search products... (e.g. laptop, printer, t-shirt)"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-12 pr-5 py-4 bg-white/80 backdrop-blur-sm border border-gray-200 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition text-gray-700"
            />
          </div>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 max-w-7xl mx-auto">
          {filteredProducts.length > 0 ? (
            filteredProducts.map((product) => (
              <div
                key={product.id}
                className="group bg-white/80 backdrop-blur-sm rounded-xl shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300 overflow-hidden border border-white/50"
              >
                {/* Image */}
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={product.img}
                    alt={product.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                </div>

                {/* Content */}
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-3">
                    {product.icon}
                    <h3 className="text-xl font-semibold text-gray-800">
                      {product.name}
                    </h3>
                  </div>
                  <p className="text-sm text-gray-600 line-clamp-2 mb-3">
                    {product.description}
                  </p>
                  {/* <p className="text-lg font-bold text-blue-700 mb-3">
                    {product.price}
                  </p>
                  <button className="w-full bg-blue-700 text-white py-2.5 rounded-lg font-medium hover:bg-blue-800 transition text-sm">
                    Get Quote
                  </button> */}
                </div>
              </div>
            ))
          ) : (
            <div className="col-span-full text-center py-12">
              <p className="text-gray-500 text-lg">
                No products found for "
                <span className="font-medium">{searchTerm}</span>".
              </p>
              <p className="text-gray-400 mt-2">
                Try searching for "laptop", "printer", or "t-shirt"
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AllProducts;
